/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddOrRemoveDocumentToNewsDto } from '../models/work-add-or-remove-document-to-news-dto';
import { WorkCreateNewsDto } from '../models/work-create-news-dto';
import { WorkDocument } from '../models/work-document';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkNews } from '../models/work-news';
import { WorkNewsReadConfirmation } from '../models/work-news-read-confirmation';
import { WorkNewsReadConfirmationsDto } from '../models/work-news-read-confirmations-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateNewsDto } from '../models/work-update-news-dto';

@Injectable({ providedIn: 'root' })
export class WorkNewsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `newsV2ControllerFindAllPaginated()` */
  static readonly NewsV2ControllerFindAllPaginatedPath = '/v2/news';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by audiences.users.id query param.
     *           <p>
     *              <b>Format: </b> filter.audiences.users.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.audiences.users.id=$not:$like:John Doe&filter.audiences.users.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.audiences.users.id'?: Array<string>;

    /**
     * Filter by showFrom query param.
     *           <p>
     *              <b>Format: </b> filter.showFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.showFrom=$not:$like:John Doe&filter.showFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.showFrom'?: Array<string>;

    /**
     * Filter by showUntil query param.
     *           <p>
     *              <b>Format: </b> filter.showUntil={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.showUntil=$not:$like:John Doe&filter.showUntil=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.showUntil'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>title</li>
     * <li>showFrom</li>
     * <li>author.firstName</li></ul>
     */
      sortBy?: Array<'title:ASC' | 'title:DESC' | 'showFrom:ASC' | 'showFrom:DESC' | 'author.firstName:ASC' | 'author.firstName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiences.users.id'?: (string | Array<string>);
'showFrom'?: (string | Array<string>);
'showUntil'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.audiences.users.id', params['filter.audiences.users.id'], {});
      rb.query('filter.showFrom', params['filter.showFrom'], {});
      rb.query('filter.showUntil', params['filter.showUntil'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkNews>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'audiences.users.id'?: (string | Array<string>);
        'showFrom'?: (string | Array<string>);
        'showUntil'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by audiences.users.id query param.
     *           <p>
     *              <b>Format: </b> filter.audiences.users.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.audiences.users.id=$not:$like:John Doe&filter.audiences.users.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.audiences.users.id'?: Array<string>;

    /**
     * Filter by showFrom query param.
     *           <p>
     *              <b>Format: </b> filter.showFrom={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.showFrom=$not:$like:John Doe&filter.showFrom=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.showFrom'?: Array<string>;

    /**
     * Filter by showUntil query param.
     *           <p>
     *              <b>Format: </b> filter.showUntil={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.showUntil=$not:$like:John Doe&filter.showUntil=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li></ul>
     */
      'filter.showUntil'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>title</li>
     * <li>showFrom</li>
     * <li>author.firstName</li></ul>
     */
      sortBy?: Array<'title:ASC' | 'title:DESC' | 'showFrom:ASC' | 'showFrom:DESC' | 'author.firstName:ASC' | 'author.firstName:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> title
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>title</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiences.users.id'?: (string | Array<string>);
'showFrom'?: (string | Array<string>);
'showUntil'?: (string | Array<string>);
};
};
}> {
    return this.newsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiences.users.id'?: (string | Array<string>);
'showFrom'?: (string | Array<string>);
'showUntil'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkNews>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'audiences.users.id'?: (string | Array<string>);
'showFrom'?: (string | Array<string>);
'showUntil'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerCreate()` */
  static readonly NewsV2ControllerCreatePath = '/v2/news';

  /**
   * Required permissions: news:create, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerCreate$Response(
    params: {
      body: WorkCreateNewsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNews>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNews>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerCreate(
    params: {
      body: WorkCreateNewsDto
    },
    context?: HttpContext
  ): Observable<WorkNews> {
    return this.newsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNews>): WorkNews => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerGetAllDropdownOptions()` */
  static readonly NewsV2ControllerGetAllDropdownOptionsPath = '/v2/news/dropdown-options';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.newsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerFindUnreadForCurrentUser()` */
  static readonly NewsV2ControllerFindUnreadForCurrentUserPath = '/v2/news/my-unread';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerFindUnreadForCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindUnreadForCurrentUser$Response(
    params: {
      limit: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkNews>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerFindUnreadForCurrentUserPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkNews>>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerFindUnreadForCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindUnreadForCurrentUser(
    params: {
      limit: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkNews>> {
    return this.newsV2ControllerFindUnreadForCurrentUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkNews>>): Array<WorkNews> => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerFindOneById()` */
  static readonly NewsV2ControllerFindOneByIdPath = '/v2/news/{id}';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNews>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNews>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkNews> {
    return this.newsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNews>): WorkNews => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerDelete()` */
  static readonly NewsV2ControllerDeletePath = '/v2/news/{id}';

  /**
   * Required permissions: news:delete, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: news:delete, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.newsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerUpdate()` */
  static readonly NewsV2ControllerUpdatePath = '/v2/news/{id}';

  /**
   * Required permissions: news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateNewsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNews>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNews>;
      })
    );
  }

  /**
   * Required permissions: news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateNewsDto
    },
    context?: HttpContext
  ): Observable<WorkNews> {
    return this.newsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNews>): WorkNews => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerAddAudienceToNews()` */
  static readonly NewsV2ControllerAddAudienceToNewsPath = '/v2/news/{id}/audiences/{audienceId}';

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerAddAudienceToNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerAddAudienceToNews$Response(
    params: {
      id: number;
      audienceId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerAddAudienceToNewsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('audienceId', params.audienceId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerAddAudienceToNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerAddAudienceToNews(
    params: {
      id: number;
      audienceId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.newsV2ControllerAddAudienceToNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerRemoveAudienceFromNews()` */
  static readonly NewsV2ControllerRemoveAudienceFromNewsPath = '/v2/news/{id}/audiences/{audienceId}';

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerRemoveAudienceFromNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerRemoveAudienceFromNews$Response(
    params: {
      id: number;
      audienceId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerRemoveAudienceFromNewsPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('audienceId', params.audienceId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerRemoveAudienceFromNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerRemoveAudienceFromNews(
    params: {
      id: number;
      audienceId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.newsV2ControllerRemoveAudienceFromNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerAddTagToNews()` */
  static readonly NewsV2ControllerAddTagToNewsPath = '/v2/news/{id}/tags/{tagId}';

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerAddTagToNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerAddTagToNews$Response(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerAddTagToNewsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('tagId', params.tagId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerAddTagToNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerAddTagToNews(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.newsV2ControllerAddTagToNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerRemoveTagFromNews()` */
  static readonly NewsV2ControllerRemoveTagFromNewsPath = '/v2/news/{id}/tags/{tagId}';

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerRemoveTagFromNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerRemoveTagFromNews$Response(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerRemoveTagFromNewsPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('tagId', params.tagId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:create, news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerRemoveTagFromNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerRemoveTagFromNews(
    params: {
      id: number;
      tagId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.newsV2ControllerRemoveTagFromNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerGetDocumentsByNewsId()` */
  static readonly NewsV2ControllerGetDocumentsByNewsIdPath = '/v2/news/{id}/documents';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerGetDocumentsByNewsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerGetDocumentsByNewsId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerGetDocumentsByNewsIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerGetDocumentsByNewsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerGetDocumentsByNewsId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.newsV2ControllerGetDocumentsByNewsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerAddDocumentToNews()` */
  static readonly NewsV2ControllerAddDocumentToNewsPath = '/v2/news/{id}/documents';

  /**
   * Required permissions: news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerAddDocumentToNews()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerAddDocumentToNews$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToNewsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNews>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerAddDocumentToNewsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNews>;
      })
    );
  }

  /**
   * Required permissions: news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerAddDocumentToNews$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerAddDocumentToNews(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToNewsDto
    },
    context?: HttpContext
  ): Observable<WorkNews> {
    return this.newsV2ControllerAddDocumentToNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNews>): WorkNews => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerRemoveDocumentFromNews()` */
  static readonly NewsV2ControllerRemoveDocumentFromNewsPath = '/v2/news/{id}/documents/{documentId}';

  /**
   * Required permissions: news:update, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerRemoveDocumentFromNews()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerRemoveDocumentFromNews$Response(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToNewsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerRemoveDocumentFromNewsPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: news:update, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerRemoveDocumentFromNews$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsV2ControllerRemoveDocumentFromNews(
    params: {
      id: number;
      body: WorkAddOrRemoveDocumentToNewsDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.newsV2ControllerRemoveDocumentFromNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerMarkAsRead()` */
  static readonly NewsV2ControllerMarkAsReadPath = '/v2/news/{id}/read';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerMarkAsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerMarkAsRead$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNewsReadConfirmation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerMarkAsReadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNewsReadConfirmation>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerMarkAsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerMarkAsRead(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkNewsReadConfirmation> {
    return this.newsV2ControllerMarkAsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNewsReadConfirmation>): WorkNewsReadConfirmation => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerConfirmRead()` */
  static readonly NewsV2ControllerConfirmReadPath = '/v2/news/{id}/read-confirmation';

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerConfirmRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerConfirmRead$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNewsReadConfirmation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerConfirmReadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNewsReadConfirmation>;
      })
    );
  }

  /**
   * Required permissions: news:read, news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerConfirmRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerConfirmRead(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkNewsReadConfirmation> {
    return this.newsV2ControllerConfirmRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNewsReadConfirmation>): WorkNewsReadConfirmation => r.body)
    );
  }

  /** Path part for operation `newsV2ControllerFindReadConfirmations()` */
  static readonly NewsV2ControllerFindReadConfirmationsPath = '/v2/news/{id}/read-confirmations';

  /**
   * Required permissions: news:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsV2ControllerFindReadConfirmations()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindReadConfirmations$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNewsReadConfirmationsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNewsV2Service.NewsV2ControllerFindReadConfirmationsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNewsReadConfirmationsDto>;
      })
    );
  }

  /**
   * Required permissions: news:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsV2ControllerFindReadConfirmations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsV2ControllerFindReadConfirmations(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkNewsReadConfirmationsDto> {
    return this.newsV2ControllerFindReadConfirmations$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNewsReadConfirmationsDto>): WorkNewsReadConfirmationsDto => r.body)
    );
  }

}
